module.exports = __webpack_public_path__ + "img/MOA_logo_2.3e255c51.png";